

const hostname = window.location.hostname;

let domain = "";

let BASE_URL = "";
let REACT_APP_LOGIN = "";
let REACT_APP_LOGOUT = "";

let localIP= process.env.REACT_APP_HOST ;
const protocol = localIP ? "http://" : "https://";
localIP = localIP ? localIP : "localhost";

function getDomain(hostname:any) {
  const parts = hostname.split(".");
  
  // If it’s just a plain domain (no subdomain), return as is
  if (parts.length <= 2) {
    return hostname;
  }

  // Drop the first part (subdomain) and return the rest
  return parts.slice(1).join(".");
}
if (hostname.includes(localIP)) {
  domain = "localhost"
  BASE_URL = `${protocol}${localIP}/assessments_platform/backend/`
  REACT_APP_LOGIN = `${protocol}${localIP}/assessments_platform/backend/login.php`
  REACT_APP_LOGOUT = `${protocol}${localIP}/assessments_platform/backend/logout.php`
} else {
  domain = getDomain(hostname);
  BASE_URL = `https://${hostname}/backend/`
  REACT_APP_LOGIN = `https://${hostname}/backend/login.php`
  REACT_APP_LOGOUT = `https://${hostname}/backend/logout.php`
}


export {
  BASE_URL,
  REACT_APP_LOGIN,
  REACT_APP_LOGOUT,
  domain
}
